import { render, staticRenderFns } from "./Decoction.vue?vue&type=template&id=1d15f155&scoped=true&"
import script from "./Decoction.vue?vue&type=script&lang=js&"
export * from "./Decoction.vue?vue&type=script&lang=js&"
import style0 from "./Decoction.vue?vue&type=style&index=0&id=1d15f155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d15f155",
  null
  
)

export default component.exports